/**
 * Logout Component
 * Handles user logout and redirects to sign-in
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import MDBox from "components/MDBox";
import { CircularProgress } from "@mui/material";

function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    // Perform logout
    logout();
    // Redirect to sign-in
    navigate("/authentication/sign-in");
  }, [logout, navigate]);

  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress color="info" />
    </MDBox>
  );
}

export default Logout;
